import React, { useRef } from 'react'
import '@ica-azure/ica-elements/IcaInputSearch'

type IcaInputSearchProps = React.JSX.IntrinsicElements['tgdb-ica-input-search']

type IcaInputSearch = IcaInputSearchProps & {
  onFocus?: (e: Event) => void
  onBlur?: (e: Event) => void
  onChange?: (e: Event) => void
  onInput?: (e: Event) => void
  onClear?: (e: Event) => void
  onSearch?: (e: Event) => void
  onKeydown?: (e: Event) => void
}

export function IcaInputSearch({
  disabled,
  invalid,
  autofocus,
  selectonfocus,
  loading,
  ...rest
}: IcaInputSearch) {
  const inputRef = useRef<HTMLInputElement>(null)

  React.useEffect(() => {
    const current = inputRef.current
    if (current) {
      if (rest.onFocus) {
        current.addEventListener('focus', rest.onFocus as EventListener)
      }
      if (rest.onBlur) {
        current.addEventListener('blur', rest.onBlur as EventListener)
      }
      if (rest.onChange) {
        current.addEventListener('change', rest.onChange as EventListener)
      }
      if (rest.onInput) {
        current.addEventListener('input', rest.onInput as EventListener)
      }
      if (rest.onClear) {
        current.addEventListener('clear', rest.onClear as EventListener)
      }
      if (rest.onSearch) {
        current.addEventListener('search', rest.onSearch as EventListener)
      }
      if (rest.onKeydown) {
        current.addEventListener('keydown', rest.onKeydown as EventListener)
      }
  
      return () => {
        if (rest.onFocus) {
          current.removeEventListener('focus', rest.onFocus as EventListener)
        }
        if (rest.onBlur) {
          current.removeEventListener('blur', rest.onBlur as EventListener)
        }
        if (rest.onChange) {
          current.removeEventListener('change', rest.onChange as EventListener)
        }
        if (rest.onInput) {
          current.removeEventListener('input', rest.onInput as EventListener)
        }
        if (rest.onClear) {
          current.removeEventListener('clear', rest.onClear as EventListener)
        }
        if (rest.onSearch) {
          current.removeEventListener('search', rest.onSearch as EventListener)
        }
        if (rest.onKeydown) {
          current.removeEventListener('keydown', rest.onKeydown as EventListener)
        }
      }
    }
  }, [rest.onFocus, rest.onBlur, rest.onChange, rest.onInput, rest.onClear, rest.onSearch, rest.onKeydown])

  return (
    <tgdb-ica-input-search
      ref={inputRef}
      disabled={disabled}
      invalid={invalid}
      autofocus={autofocus}
      selectonfocus={selectonfocus}
      loading={loading}
      {...rest}
    />
  )
}